import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

export type SecureChangeParams = { password: string } | { emailCode: string };

@Injectable({ providedIn: 'root' })
export class SecureChangeHttpClient {
  private readonly httpApi = inject(HttpApiService);

  public fetchToken(
    secureChange: SecureChangeParams,
    skipCompany: boolean = false,
  ): Observable<{ secureChangeToken: string }> {
    return this.httpApi.post(`/secure_change/token`, null, { secureChange }, { skipCompany });
  }

  public requestEmailCode(): Observable<any> {
    return this.httpApi.post('/secure_change/email_code', null, null);
  }
}
